// extracted by mini-css-extract-plugin
export var cartContainer = "_o4-4";
export var gray = "_o4-1";
export var itemContainer = "_o4-2";
export var itemDetails = "_o4-3";
export var strong = "_o4-0";